import styled from 'styled-components';

export const StyledApplication = styled.div`
  margin: 0px;
  padding: 30px;
  min-height: 750px;
`;
export const StyledSubHeading = styled.div`
  display: flex;
  justify-content: center;
  
  font-weight: bold;
  padding: 20px;
`;